module.exports = __webpack_public_path__ + "static/level-6-card.42e20040.png";